import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";

export default function DocTypeCfgEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ rec_type: 0, doc_type: "", gestiune_id: 0, contr_account_id: 0 });

  useEffect(() => {
    let alive = true;
    api.get(`/doc_type_cfg/${id}`)
      .then((res) => {
        if (!alive) return;
        const d = res.data || {};
        setForm((f) => ({ ...f, doc_type: d.doc_type ?? "", rec_type: d.rec_type ?? 0, gestiune_id: d.gestiune_id ?? 0, contr_account_id: d.contr_account_id ?? 0 }));
        setLoading(false);
      })
      .catch((err) => {
        alert("Eroare la încărcare: " + (err.response?.data?.detail || err.message));
        setLoading(false);
      });
    return () => { alive = false; };
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const payload = { ...form };
      
      payload.rec_type = Number(form.rec_type) || 0;
      payload.gestiune_id = Number(form.gestiune_id) || 0;
      payload.contr_account_id = Number(form.contr_account_id) || 0;
      await api.put(`/doc_type_cfg/${id}`, payload);
      navigate("/doc_type_cfg");
    } catch (err) {
      alert("Eroare la actualizare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return null; // sau un spinner

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Editare DocTypeCfg #{"{"}{id}{"}"}</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>rec_type</Form.Label>
                  <Form.Control
                    type="number"
                    name="rec_type"
                    value={form.rec_type ?? 0}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>doc_type</Form.Label>
                  <Form.Control
                    type="text"
                    name="doc_type"
                    value={form.doc_type ?? ""}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>gestiune_id</Form.Label>
                  <Form.Control
                    type="number"
                    name="gestiune_id"
                    value={form.gestiune_id ?? 0}
                    onChange={handleChange}
                    
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>contr_account_id</Form.Label>
                  <Form.Control
                    type="number"
                    name="contr_account_id"
                    value={form.contr_account_id ?? 0}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>Salvează</Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
}
